import React, { useEffect, useState } from 'react'
import { FilterItemSelectProps } from '@root-gipro/shared/Filter/models/filter-item-select.props'
import { isEqual } from 'lodash'
import { SelectSearch } from '@root-gipro/shared/FormElements'

const FilterItemSelect: React.FC<FilterItemSelectProps> = ({
	value,
	setValue,
	name,
	placeholder,
	isDisable,
	fieldName,
	items,
}) => {
	const [selectValue, setSelectValue] = useState(value || [])
	useEffect(() => {
		if (!isEqual(value, selectValue)) {
			setSelectValue(value || [])
		}
	}, [value])

	return (
		<div className='aside-filter__select-filter'>
			<SelectSearch
				value={value}
				setValue={setValue}
				name={name}
				placeholder={placeholder}
				isDisable={isDisable}
				fieldName={fieldName}
				items={items}
			/>
		</div>
	)
}

export default FilterItemSelect
